import Vue from 'vue'
import './plugins/bootstrap-vue'
import TheApp from './TheApp.vue'
import store from './store'
import router from './router'
import i18n from './i18n'
import axios from 'axios'
import { stompService } from '@rrze/vue-encore'
import qs from 'qs'
import VueClipboard from 'vue-clipboard2'
import { sfcSetup } from './helpers/sfc.helper'

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.prototype.$stompService = stompService

Vue.config.productionTip = false

// workaround for sync modifier, see also https://github.com/vuejs/vue/issues/6428#issuecomment-358327547
// Vue.prototype.$emitCase = function (name, ...args) {
//   const camelCaseName = name.toLowerCase().replace(/-(.)/g,
//     (_, g) => g.toUpperCase())
//   this.$emit(name, ...args)
//   this.$emit(camelCaseName, ...args)
// }

// configure default axios
axios.defaults.paramsSerializer = pars => qs.stringify(pars, { arrayFormat: 'repeat' })
axios.interceptors.response.use(
  // Return a successful response back to the calling service
  response => {
    store.commit('auth/resetSessionTimer')
    if (!store.state.auth.status.serverOnline) {
      store.commit('auth/serverOnline')
    }
    return response
  },
  // Return any error which is not due to authentication back to the calling service
  error => {
    if (error.response) {
      if (error.response.status !== 401) {
        store.commit('auth/resetSessionTimer')
        return new Promise((resolve, reject) => {
          reject(error)
        })
      }
    } else {
      if (store.state.auth.status.serverOnline) {
        store.commit('auth/serverOffline')
      }
      return new Promise((resolve, reject) => {
        reject(error)
      })
    }

    store.dispatch('auth/ping')
    return store.dispatch('auth/createUnauthorizedRequest', error.config)
  }
)

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  const auth = store.state.auth || {}
  const csrfToken = auth.csrfToken || (auth.user || {}).csrfToken // default usage or released if enabled
  // console.warn('The current csrfToken is:', csrfToken)
  if (csrfToken) {
    config.headers['X-Csrf-Token'] = csrfToken
  }

  return config
})

Vue.prototype.$axios = axios

sfcSetup(Vue)

new Vue({
  store,
  router,
  i18n,
  render: h => h(TheApp)
}).$mount('#app')
